const size = 36;
const classes = {
  marker: (variant:string) =>
    ({
      height: size,
      zIndex: variant === 'posted' ? 1 : -1,
      backgroundColor: `pharmacist.${variant}`,
      width: size,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      borderRadius: size / 2,
    }),
  markerText: {
    color: 'white',

  },
};

export default classes;
